<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-07-26 19:11:19
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>溢价管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTabAdd">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-page-header @back="goBack" :content="title"> </el-page-header>
          </div>
          <el-form
            label-position="right"
            :model="ruleForm1"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item label="职业" prop="type">
              <el-select
                v-model="ruleForm1.type"
                placeholder="请选择"
                style="margin-right: auto"
              >
                <el-option label="全部" value="0"> </el-option>
                <el-option
                  :label="item.title"
                  :value="item.id"
                  v-for="(item, index) in zhenshu"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分类" prop="type1">
              <el-select
                v-model="ruleForm1.type1"
                placeholder="请选择"
                style="margin-right: auto"
                @change="selectType"
              >
                <el-option
                  :label="item.title"
                  :value="item.id"
                  v-for="(item, index) in typeList"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="描述" prop="select">
              <el-select
                v-model="ruleForm1.select"
                placeholder="请选择"
                style="margin-right: auto"
              >
                <el-option
                  :label="item.propDesc"
                  :value="item.propValue"
                  v-for="(item, index) in niticList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务省" prop="send">
              <el-select
                v-model="ruleForm1.send"
                placeholder="请选择"
                style="margin-right: auto"
                @change="cityChange"
              >
                <el-option
                  v-for="(item, index) in city"
                  :key="item.adcode"
                  :label="item.name"
                  :value="item.adcode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="服务城市"
              prop="weixin"
              v-if="ruleForm1.send != '100000'"
            >
              <el-select
                v-model="ruleForm1.weixin"
                placeholder="请选择"
                style="margin-right: auto"
              >
                <el-option
                  v-for="(item, index) in city1"
                  :key="item.adcode"
                  :label="item.name"
                  :value="item.adcode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户溢价" prop="address">
              <el-input
                v-model="ruleForm1.address"
                placeholder="请输入用户溢价"
              ></el-input>
            </el-form-item>
            <el-form-item label="保安溢价" prop="tel">
              <el-input
                v-model="ruleForm1.tel"
                placeholder="请输入保安溢价"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button @click="resetForm1('ruleForm')">取消</el-button>
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                style="margin-right: auto"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      title: "新增溢价规则",
      ruleForm1: {
        type: "",
        type1: "",
        send: "",
        select: "",
        address: "",
        tel: "",
        weixin: "",
      },
      rules: {
        type: [{ required: true, message: "必选项", trigger: "change" }],
        type1: [{ required: true, message: "必选项", trigger: "change" }],
        send: [{ required: true, message: "必选项", trigger: "change" }],
        tel: [{ required: true, message: "必填项", trigger: "blur" }],
        select: [{ required: true, message: "必选项", trigger: "change" }],
        weixin: [{ required: true, message: "必填项", trigger: "change" }],
        address: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      options: [],
      editId: "",
      niticList: [],
      city: [],
      city1: [],
      zhenshu: [],
      typeList: [],
    };
  },
  created: function () {
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.title = "编辑溢价";
      this.getType();
      this.getDetail();
    }
    this.getcity();
    this.getData();
    this.getType();
  },
  methods: {
    getData() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "pricePremiumType_occupation",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.zhenshu = JSON.parse(data.items[0].propValue);
        })
        .catch()
        .finally();
    },
    getType() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "pricePremiumType_premium_classification",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.typeList = JSON.parse(data.items[0].propValue);
        })
        .catch()
        .finally();
    },
    selectType(val) {
      let param = {
        key: "",
      };
      for (var i = 0; i < this.typeList.length; i++) {
        if (val == this.typeList[i].id) {
          param.key = this.typeList[i].lvKey;
        }
      }
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          let arr = [];
          for (var x = 0; x < data.length; x++) {
            let obj = {};
            obj.propDesc = JSON.parse(data[x].propDesc).title;
            obj.propValue = data[x].propValue.toString();
            arr.push(obj);
          }
          this.niticList = arr;
        })
        .catch()
        .finally();
    },
    getcity() {
      let param = {
        type: 0,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          let arr = data;
          arr.shift();
          this.city = arr;
          if (this.ruleForm1.send != "" && this.ruleForm1.send != "100000") {
            this.getcity1();
          }
        })
        .catch()
        .finally();
    },
    cityChange() {
      if (this.ruleForm1.send != "" && this.ruleForm1.send != "100000") {
        this.getcity1();
      }
    },
    getcity1() {
      let param = {
        type: 1,
        adcode: this.ruleForm1.send,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city1 = data;
        })
        .catch()
        .finally();
    },
    cityChange() {
      this.getcity1();
    },
    cityChange1() {
      this.getcity2();
    },
    goBack() {
      this.$router.go(-1);
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.goBack();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            bodyguardsPremium: this.ruleForm1.tel,
            careerType: this.ruleForm1.type,
            type: this.ruleForm1.type1,
            customPremium: this.ruleForm1.address,
            detailValue: this.ruleForm1.select,
            provinceCode: this.ruleForm1.send,
            cityCode: this.ruleForm1.weixin,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/premium/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.goBack();
              })
              .catch()
              .finally();
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/premium/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.goBack();
              })
              .catch()
              .finally(() => {
                this.editId = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getDetail() {
      this.$axios
        .post(`/admapi/premium/get/${this.editId}`)
        .then(({ data }) => {
          console.log(data);
          this.selectType(data.type);
          this.ruleForm1.type = data.careerType.toString();
          this.ruleForm1.type1 = data.type.toString();
          this.ruleForm1.select = data.detailValue;
          this.ruleForm1.send = data.provinceCode.toString();
          this.ruleForm1.address = data.customPremium;
          this.ruleForm1.tel = data.bodyguardsPremium;
          this.ruleForm1.weixin = data.cityCode.toString();
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  margin: 0 auto;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
